import { encodeContextHash } from '@common/defaults/ContextHash';
import { getHostByHostname, LocaleByHost, PlatformByHost } from '@common/utils/HostUtil';

export const getDummyContextHashFromHost = ({ host: receivedHost }: { host: string }): string | null => {
    const hostname = new URL(`http://${receivedHost.split(':')[0]}`).hostname;
    const host = getHostByHostname(hostname);
    if (!host) return null;
    const platformID = PlatformByHost[host];
    const locale = LocaleByHost[host];
    return encodeContextHash({
        hostname,
        platformID,
        locale,
        contextID: 0,
        allowAds: undefined,
        allowExternalSnippets: undefined,
        allowBetting: undefined,
        allowPremium: undefined,
        allowTracking: undefined,
        cacheBuster: undefined,
        experimentGroup: 'a',
        isMobileApp: undefined,
        isPlatformContext: undefined,
        isReadiness: undefined,
        premiumSubscriptionTag: undefined,
    });
};
